import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import { Navigate } from 'react-router';

// pages
const Seminar = Loadable(lazy(() => import('pages/events/seminar')));

// ==============================|| APPS ROUTING ||============================== //

const EventsRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'events',
          element: <Navigate to="seminar" />
        },
        {
          path: 'events/seminar',
          element: <Seminar />
        }
      ]
    }
  ]
};

export default EventsRoutes;
